import _default from './safeHtml';
export { _default as default };
